<template>
  <div class="modal-overflow">
    <div class="table-responsive table-full-width">
      <h6>Associate one of these existing Streets with {{ data.cities[0] }}?</h6>
      <el-table class="table-striped"
                :data="streets"
                row-key="name"
                border
                style="width: 100%;">
        <el-table-column prop="name" label="Street">
        </el-table-column>
        <el-table-column label="Cities">
          <template slot-scope="props">
            {{ uniqueCities(props.row.cities) | toCsv }}
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          fixed="right"
          align="center"
          label="Actions">
          <template slot-scope="props">
            <button @click="addCityToStreet(props.row)" class="btn btn-fill btn-info btn-sm btn-save">Add</button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <hr />
    <div style="margin-top: 12px;">
      <h6>or Create New Street to be Associated With {{ data.cities[0] }}</h6>
      <div class="row">
        <div class="col-md-4"></div>
          <div class="col-md-4 form-group" style="padding: 0;">
            <label>New Street Name</label>
            <el-input v-model="streetName"
                      clearable
                      ref="streetInput"
                      placeholder="Street Name"/>
          </div>
      </div>
      <div class="row form-group d-flex justify-content-center">
        <button type="button" :disabled="isProcessing" @click="createStreet" class="btn btn-fill btn-info">
          Create
        </button>
        <button type="button" @click="closeModal" class="btn btn-fill btn-info">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import Constants from 'src/utilities/constants'
  import _ from 'lodash'
  import {notifySuccess, notifyError, saveStreet} from 'src/utilities/utils'

  export default {
    props: ['data'],
    computed: {
      streets() {
        return this.$store.getters['streets/results']
      }
    },
    data() {
      return {
        addStreet: false,
        streetName: null,
        isProcessing: false
      }
    },
    methods: {
      uniqueCities(cities) {
        return _.uniq(cities)
      },
      async createStreet() {
        this.addStreet = true
        this.isProcessing = true

        const payload = {
          active: this.data.active,
          cities: this.data.cities,
          name: this.streetName
        }

        this.$store.commit('streets/hydrateEdit', payload)

        await saveStreet(this)
        this.isProcessing = false
      },
      closeModal() {
        this.$emit('close')
      },
      async addCityToStreet(street) {
        this.addStreet = true
        street.cities.push(this.data.cities[0])

        const putPayload = {
          endpoint: 'streets',
          id: street.id,
          data: street
        }
        const response = await this.$store.dispatch('put', putPayload)

        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          notifySuccess(this, `${this.data.cities[0]} added to ${street.name} successfully`)
          this.$eventHub.$emit('streetSaved', street)
          this.$emit('close')
          return
        }

        notifyError(this, `Failed to ${this.data.cities[0]} add to ${street.name} successfully`)
      }
    },
    async mounted() {
      await this.$store.dispatch('streets/fetchByNameStartsWithForResultsModal', this.data.name)
      this.streetName = this.data.name
      this.$refs.streetInput.$el.querySelector("input").focus()
    },
    destroyed() {
      if (!this.addStreet) {
        this.$eventHub.$emit('noStreetSaved')
      }
    }
  }
</script>
